import Drawer from '../../../../Components/Drawer';
import USDTGroup from '../../../../assets/images/withdrawal/withdraw-processing-usdt-icon.png';
import WithdrawErrorShine from '../../../../assets/images/withdrawal/withdraw-error-shine.png';

type TWithdrawErrorModalProps = {
    open: boolean;
    onClose: () => void;
}

function WithdrawErrorModal({ onClose, open }: TWithdrawErrorModalProps) {
  return (
    <Drawer
      open={open}
      onClose={onClose}
      side="bottom"
      closeStroke="gray-10"
      wrapperClassName="px-4 bg-withdrawModalErrorBg rounded-t-[20px] overflow-hidden text-[white] relative"
    >
      <div
        className="
            font-Bangers
            flex flex-col items-center
        "
      >
        <div
          className="
            z-[1]
            flex flex-col items-center
            transform translate-y-[-10%]
          "
        >
          <img
            src={USDTGroup}
            alt="usdt-icon"
            className="
                transform translate-y-[10%]
                my-6
            "
          />
          <span className="text-[32px] leading-[27px]">WITHDRAWAL FAILED</span>
          <span className="font-Inria text-xs max-w-[289px] mt-3 text-[#B5C4FC]">Something went wrong. Give it another shot.</span>
        </div>
        <img
          src={WithdrawErrorShine}
          alt="withdraw-shine"
          className="
            absolute
            inset-0
          "
        />
      </div>
    </Drawer>
  );
}

export default WithdrawErrorModal;
